/**
 * @generated SignedSource<<aa9a13b86d58ed106c3e764bb5b8335a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SingleExternalProjectMemberFormQuery$variables = {
  ext_person_id: number;
  ext_project_id: number;
};
export type SingleExternalProjectMemberFormQuery$data = {
  readonly current_user: {
    readonly account: {
      readonly ext_projects: ReadonlyArray<{
        readonly ext_project_members: ReadonlyArray<{
          readonly ext_person: {
            readonly email: string | null | undefined;
            readonly first_name: string;
            readonly id: number;
            readonly last_name: string;
          };
          readonly id: number;
        }>;
        readonly id: number;
        readonly name: string;
      }>;
      readonly id: number;
    };
    readonly id: number;
  } | null | undefined;
};
export type SingleExternalProjectMemberFormQuery = {
  response: SingleExternalProjectMemberFormQuery$data;
  variables: SingleExternalProjectMemberFormQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ext_person_id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ext_project_id"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "users",
    "kind": "LinkedField",
    "name": "current_user",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "accounts",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "fields": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "_eq",
                        "variableName": "ext_project_id"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "id"
                  }
                ],
                "kind": "ObjectValue",
                "name": "where"
              }
            ],
            "concreteType": "ext_project",
            "kind": "LinkedField",
            "name": "ext_projects",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Literal",
                        "name": "deleted",
                        "value": {
                          "_eq": false
                        }
                      },
                      {
                        "fields": [
                          {
                            "kind": "Variable",
                            "name": "_eq",
                            "variableName": "ext_person_id"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "ext_person_id"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "where"
                  }
                ],
                "concreteType": "ext_project_member",
                "kind": "LinkedField",
                "name": "ext_project_members",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ext_person",
                    "kind": "LinkedField",
                    "name": "ext_person",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "first_name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "last_name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SingleExternalProjectMemberFormQuery",
    "selections": (v3/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SingleExternalProjectMemberFormQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "01a5e4f9ea2ea3a7cd9c2d7f8bde43a5",
    "id": null,
    "metadata": {},
    "name": "SingleExternalProjectMemberFormQuery",
    "operationKind": "query",
    "text": "query SingleExternalProjectMemberFormQuery(\n  $ext_project_id: Int!\n  $ext_person_id: Int!\n) {\n  current_user {\n    id\n    account {\n      id\n      ext_projects(where: {id: {_eq: $ext_project_id}}) {\n        id\n        name\n        ext_project_members(where: {deleted: {_eq: false}, ext_person_id: {_eq: $ext_person_id}}) {\n          id\n          ext_person {\n            id\n            first_name\n            last_name\n            email\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d83359ea0d3ebdf6779a57f995fb7012";

export default node;
